// src/store.js
import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

const STORAGE_KEY = "bamboo_user";

// Recupera el usuario guardado en localStorage al arrancar la app,
// para que el estado de sesión sobreviva a un F5.
function cargarUsuarioGuardado() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch (e) {
    return null;
  }
}

export default new Vuex.Store({
  state: {
    user: cargarUsuarioGuardado(),
    debeCambiarPassword: false,
    snackbar: {
      mostrar: false,
      mensaje: "",
      color: "error"
    }
  },
  mutations: {
    setUser(state, user) {
      state.user = user;
      // Persistimos el usuario para que sobreviva a recargas de página.
      localStorage.setItem(STORAGE_KEY, JSON.stringify(user));
    },
    setDebeCambiarPassword(state, valor) {
      state.debeCambiarPassword = valor;
    },
    logout(state) {
      state.user = null;
      state.debeCambiarPassword = false;

      // Limpiamos TODO lo relacionado a la sesión, no solo el store.
      localStorage.removeItem(STORAGE_KEY);
      localStorage.removeItem("idUsuario");
      localStorage.removeItem("usuario");
      localStorage.removeItem("rol");
      localStorage.removeItem("nombreGimnasio");
      localStorage.removeItem("logoGimnasio");
    },
    mostrarSnackbar(state, payload) {
      state.snackbar.mostrar = true;
      state.snackbar.mensaje = payload.mensaje;
      state.snackbar.color = payload.color || "error";
    },
    ocultarSnackbar(state) {
      state.snackbar.mostrar = false;
    },
    mostrarMensaje(state, payload) {
      state.snackbar.mostrar = true;
      state.snackbar.mensaje = payload.texto || payload.mensaje;
      state.snackbar.color = payload.color || "error";
    }
  },
  getters: {
    isLoggedIn: state => !!state.user,
    userRole: state => (state.user ? state.user.rol.toLowerCase() : null),
    debeCambiarPassword: state => state.debeCambiarPassword
  }
});


// WEBPACK FOOTER //
// ./src/store.js